/**
 * Gets response header value from Request, Response, or XMLHttpRequest.
 *
 * Unified interface for accessing headers across different APIs.
 *
 * @param r - Request, Response, or XMLHttpRequest object
 * @param header - Header name to retrieve
 * @param s - Default value if header not found (default: "")
 * @returns Header value or default
 *
 * @example
 * ```ts
 * import { ResponseHeader } from "@pdfking/tfunc"
 *
 * const contentType = ResponseHeader(response, "content-type", "text/plain")
 * ```
 */
export const ResponseHeader = (
  r: Request | Response | XMLHttpRequest,
  header: string,
  s: string = ""
): string =>
  ("headers" in r ? r.headers.get(header) : r.getResponseHeader(header)) || s
